import { get_api_path } from "services/api";
import { store } from "../store";
import { sessioned_client } from "./auth";

export async function list({ query }) {
  const url = get_api_path("wallet/list", query);
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function detail(wallet_id) {
  const url = get_api_path("wallet/detail", {}, { wallet_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { model } = response.data.result;
  return { model };
};

export async function del(wallet_id) {
  const url = get_api_path("wallet/delete", {}, { wallet_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};

export async function update(wallet_id, data) {
  const url = get_api_path("wallet/update", {}, { wallet_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create(data) {
  const url = get_api_path("wallet/create");
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function transact(wallet_id, data) {
  const url = get_api_path("wallet/transact", {}, { wallet_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};